import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { TransferHttpCacheModule } from '@nguniversal/common';

import { APP_BASE_HREF, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from './../environments/environment';

import { mainRoutes } from './app.routes';

import { SharedModule } from './shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { PublicComponent } from './public/public.component';
import { LoginComponent } from './public/login/login.component';
import { HttpModule } from '@angular/http';
import { NotifierService } from './system/shared/notifier/notifier.service';
import { SystemModule } from './system/system.module';
import { NewPasswordComponent } from './public/new-password/new-password.component';
import { RecoveryPasswordComponent } from './public/recovery-password/recovery-password.component';

import { AuthServiceConfig, SocialLoginModule } from 'angularx-social-login';
import { GoogleLoginProvider } from 'angularx-social-login';


const config = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider('757362652666-qsg8i50h37k2ti0gjeos5psejmi2bbsl.apps.googleusercontent.com')
  }
]);

export function provideConfig() {
  return config;
}
@NgModule({
  declarations: [
    AppComponent,
    PublicComponent,
    LoginComponent,
    NewPasswordComponent,
    RecoveryPasswordComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'my-app' }),
    HttpClientModule,
    HttpModule,
    RouterModule.forRoot(mainRoutes),
    // CoreModule,
    SharedModule,
    BrowserAnimationsModule,
    TransferHttpCacheModule,
    SystemModule,
    SocialLoginModule
  ],

  bootstrap: [AppComponent],
  providers: [
    { provide: AuthServiceConfig, useFactory: provideConfig },
    NotifierService,
    {
      provide: APP_BASE_HREF,
      useValue: `${environment.BASE_URL}`
    }, { provide: LocationStrategy, useClass: HashLocationStrategy }
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts